import { useEffect, useState } from "react";

// Mounts children only after the browser has an idle period (post-LCP).
// Cuts non-critical widgets (chat, WhatsApp, cookie banner) out of the initial
// JS payload's execution path and out of the first-paint work. Non-mobile
// devices still get instant behaviour because idle fires almost immediately;
// slow mobile CPUs benefit most.
//
// `timeout` guarantees mount within N ms even if the browser stays busy.
export default function IdleMount({ children, timeout = 2500 }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let idleHandle;
    let timerHandle;
    const mount = () => setReady(true);

    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      idleHandle = window.requestIdleCallback(mount, { timeout });
    } else {
      timerHandle = setTimeout(mount, 800);
    }

    return () => {
      if (idleHandle && "cancelIdleCallback" in window) {
        window.cancelIdleCallback(idleHandle);
      }
      if (timerHandle) clearTimeout(timerHandle);
    };
  }, [timeout]);

  if (!ready) return null;
  return children;
}
